import * as React from "react";
import GroupList from "../../presentations/GroupList";

const GroupListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    console.log('on edit group list container ---');
    console.log(rowData);
    onEdit(rowData);
  }

  return (
    <div>
      <GroupList onEdit={handleOnEdit}></GroupList>
    </div>
  );
};

export default GroupListContainer;
